<template>
  <div class="flex gap-x-3 rounded-full bg-white px-4 py-2 shadow-md" :class="cn(props.class)">
    <div
      v-for="(item, index) in scrollSnaps"
      :key="index"
      class="border-1 h-2 w-2 cursor-pointer rounded-full border border-solid border-gray-400"
      :class="index === selectedIndex ? '!border-black bg-black' : 'bg-transparent'"
      @click="scrollTo(index)"
    />
  </div>
</template>
<script setup lang="ts">
import { useCarousel } from './useCarousel';
import { cn } from '@lib/utils';

const props = defineProps({
  class: {
    type: String,
    default: '',
  },
});

const { scrollTo, selectedIndex, scrollSnaps } = useCarousel();
</script>
